var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("ul", { staticClass: "contextmenu" }, [
      _c(
        "li",
        {
          on: {
            click: function ($event) {
              return _vm.addConnect()
            },
          },
        },
        [_vm._v("添加连接")]
      ),
      _c(
        "li",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.typeCode !== "channel",
              expression: "typeCode !== 'channel'",
            },
          ],
          staticClass: "edit-btn",
          on: {
            click: function ($event) {
              return _vm.showUpdataDrawe()
            },
          },
        },
        [_vm._v("编辑")]
      ),
      _c(
        "li",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.typeCode !== "channel" && _vm.typeCode !== "real",
              expression: "typeCode !== 'channel' && typeCode !== 'real'",
            },
          ],
          staticClass: "delete-btn",
          on: {
            click: function ($event) {
              return _vm.handleDelete()
            },
          },
        },
        [_vm._v(" 删除 ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }